import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatTextService {

  addSpace(data: string) {
    if (data == null) {
      return data;
    }
    return data.replace(/,(\S)/g, ', $1');
  }
}
